/**
 * Numbers only directive
 * This masks an input by ensuring only numeric values are entered into a field.
 * It has been updated to work cross-browser, even on Android!!
 * @example `<input type="text" v-numbers-only />`
 */

/* eslint-disable */
var oldValue;
// regex translation
// [] character set
// \d matches any digit character (0-9 / numbers only)
// ,. because we also want period and commas
// * quantifier: matches 0 or more of the preceding token (needed for clearing input)
const regex = new RegExp(/[\d,.]*/);

// Function unmasking input values
// Removes every non-digit character or characters that aren't period or comma
// regex translation
// ^ negated set: match any character not in this set
// [] this set, which is any digit or comma or period
function unmask(value) {
  return value.replace(new RegExp(/[^\d,.]/), '');
}

Vue.directive('numbersOnly', {
  bind(el) {
    el.addEventListener('keydown', (event) => {
      oldValue = el.value;
      // check for keycode events just in case
      // useful for IE and Firefox, which still had issues
      if (event.keyCode === 8 || event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 9
        || event.keyCode === 190 || event.keyCode === 110 || event.keyCode === 188 || event.keyCode === 91 || event.keyCode === 86) {
        return true;
      } else if ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105)) {
        return true;
      }
      event.preventDefault();
      return false;
    });
    // need to use the input event because keydown and keypress can be unreliable
    // thanks Android
    el.addEventListener('input', () => {
      let newValue = unmask(el.value);

      if (newValue.match(regex)) {

        if (newValue !== "") {
          el.value = newValue;
        } else {
          el.value = "";
        }
      } else {
        el.value = oldValue;
      }
    });
  },
});



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/shared/vue/directives/numbersOnly.js